export default __webpack_public_path__ + "static/media/glue-down.d2bedc96.svg";